import { render, staticRenderFns } from "./MissedCalls.vue?vue&type=template&id=0e50de6e&"
import script from "./MissedCalls.vue?vue&type=script&lang=js&"
export * from "./MissedCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports